import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function NavBar({ loggedIn }) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="sticky top-0 z-50 bg-white border-b border-slate-100">
            <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 font-black text-lg text-slate-900 tracking-tight no-underline"
                >
                    <span className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white text-sm leading-none">
                        📅
                    </span>
                    Scheduly
                </Link>

                <div className="flex items-center gap-5">
                    {/* Desktop nav links */}
                    <Link
                        to="/plans"
                        className="hidden sm:block text-slate-500 text-sm font-medium hover:text-slate-900 no-underline transition-colors"
                    >
                        Pricing
                    </Link>
                    <Link
                        to="/blog"
                        className="hidden sm:block text-slate-500 text-sm font-medium hover:text-slate-900 no-underline transition-colors"
                    >
                        Blog
                    </Link>
                    <Link
                        to={loggedIn ? '/account' : '/login'}
                        className="hidden sm:block text-slate-500 text-sm font-medium hover:text-slate-900 no-underline transition-colors"
                    >
                        {loggedIn ? 'My Account' : 'Login'}
                    </Link>
                    <Link
                        to="/checkout?plan=Clubhouse"
                        className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold px-5 py-2 rounded-lg no-underline transition-colors whitespace-nowrap"
                    >
                        3-Month Free Trial
                    </Link>

                    {/* Mobile hamburger button */}
                    <button
                        className="sm:hidden flex flex-col gap-1.5 p-1 cursor-pointer"
                        onClick={() => setMenuOpen((o) => !o)}
                        aria-label="Toggle menu"
                    >
                        <span className={`block w-5 h-0.5 bg-slate-600 transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
                        <span className={`block w-5 h-0.5 bg-slate-600 transition-all ${menuOpen ? 'opacity-0' : ''}`} />
                        <span className={`block w-5 h-0.5 bg-slate-600 transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
                    </button>
                </div>
            </div>

            {/* Mobile dropdown */}
            {menuOpen && (
                <div className="sm:hidden border-t border-slate-100 bg-white px-6 py-4 flex flex-col gap-4">
                    <Link
                        to="/plans"
                        className="text-slate-700 text-sm font-medium no-underline"
                        onClick={() => setMenuOpen(false)}
                    >
                        Pricing
                    </Link>
                    <Link
                        to="/blog"
                        className="text-slate-700 text-sm font-medium no-underline"
                        onClick={() => setMenuOpen(false)}
                    >
                        Blog
                    </Link>
                    <Link
                        to={loggedIn ? '/account' : '/login'}
                        className="text-slate-700 text-sm font-medium no-underline"
                        onClick={() => setMenuOpen(false)}
                    >
                        {loggedIn ? 'My Account' : 'Login'}
                    </Link>
                </div>
            )}
        </nav>
    );
}
